// extracted by mini-css-extract-plugin
module.exports = {"appInfo":"AppInfo_appInfo__2sRUT","content":"AppInfo_content__2fM65","icon":"AppInfo_icon__1rul6","appName":"AppInfo_appName__1krpJ","dividers":"AppInfo_dividers__2NL7A"};